import React, { useState } from 'react';
import styles from '../MailTemplateSent.module.scss';
import { IconWrapper } from '../../../../Atoms/icons/Icon';
import Tooltip from '../../../../Atoms/Tooltip/Tooltip';
const MailHeader = ({
  selectedMail,
  setReply,
  setIsNewMail = null,
  onDelete,
  mailById,
}) => {
  const [hoverFlag, setHoverFlag] = useState(false);
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        {/* <div
          onMouseEnter={() => setHoverFlag(true)}
          onMouseLeave={() => setHoverFlag(false)}
        >
          <IconWrapper
            icon={hoverFlag ? 'filledFlag' : 'flag'}
            className={styles.star}
          />
        </div> */}
        <p> {mailById?.dto?.subject || '(no subject)'}</p>
      </div>
      <div>
        <Tooltip content='Reply'>
          {' '}
          <IconWrapper
            icon='preForward'
            className={styles.icon}
            color='#7F7F7F'
            onClick={() => {
              setReply((prev) => ({
                ...prev,
                show: true,
                type: 'one',
                content: mailById?.dto,
                more: true,
              }));
              if (mailById?.dto !== null) setIsNewMail(true);
            }}
          />
        </Tooltip>

        <Tooltip content='Reply All'>
          <IconWrapper
            icon='doubleForward'
            className={styles.icon}
            color='#7F7F7F'
            onClick={() => {
              setReply((prev) => ({
                ...prev,
                show: true,
                type: 'all',
                content: mailById?.dto,
                more: true,
              }));
              if (setIsNewMail !== null) setIsNewMail(true);
            }}
          />
        </Tooltip>

        <Tooltip content='Forward'>
          <IconWrapper
            icon='forward'
            className={styles.icon}
            color='#7F7F7F'
            onClick={() => {
              setReply((prev) => ({
                ...prev,
                show: true,
                type: 'forward',
                content: mailById?.dto,
                more: true,
              }));
              if (setIsNewMail !== null) setIsNewMail(true);
            }}
          />
        </Tooltip>
        <Tooltip content='Delete' red>
          <IconWrapper
            icon='delete'
            className={`${styles.icon} ${styles.delete}`}
            color='#7F7F7F'
            onClick={() => onDelete(mailById?.dto?.id)}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default MailHeader;
